import { forwardRef } from 'react';

import { Button } from '..';
import { TProps } from '../types/TProps';

export const TextButtonLarge = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <Button ref={ref} className={['btn--text-lg', className].filter(Boolean).join(' ')} {...props} />
));

TextButtonLarge.displayName = 'TextButtonLarge';
